/* eslint-disable react/prop-types */ // TODO: add props
import cx from 'classnames';

const createMarkup = (text) => ({ __html: text });

const MultiChoiceOption = ({
  allowMultiSelect,
  value,
  showResult,
  checked,
  isCorrect,
  onChange,
  label,
}) => (
  <li className="radio">
    <label>
      <div
        className={cx('input-wrapper', {
          'is-correct': isCorrect,
          checked: checked,
          'show-result': showResult,
        })}
      >
        <input
          type={!allowMultiSelect ? 'radio' : 'checkbox'}
          checked={checked}
          value={value}
          onChange={onChange}
        />
        <span dangerouslySetInnerHTML={createMarkup(label)} />
      </div>
    </label>
  </li>
);

export default MultiChoiceOption;
